import { render, staticRenderFns } from "./View-User-Txt.vue?vue&type=template&id=4b578b74&"
import script from "./View-User-Txt.vue?vue&type=script&lang=js&"
export * from "./View-User-Txt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports